import anime from 'animejs';

import {Component} from 'lowkey-component';

export class AnchorScroll extends Component {
  _scroll(selector: string) {
    if (selector !== '#') {
      const target = document.querySelector(selector);
      const {top = 0} = target?.getBoundingClientRect() || {};
      // for ie11
      const windowScrollY = window.scrollY || window.pageYOffset;
      const y = top + windowScrollY;
      const scroll = {y: windowScrollY};

      anime({
        duration: 800,
        easing: 'easeOutCubic',
        targets: scroll,
        update: () => {
          window.scrollTo(0, scroll.y);
          // window.scrollToは、window.addEventListener('scroll')が他のコンポーネントでキャッチできないのでイベントを発火する
          window.dispatchEvent(new Event('scroll'));
        },
        y,
      });
    }
  }

  didMount() {
    this.on('click', (e: Event) => {
      const target = this.element?.getAttribute('href') || '';
      this._scroll(target);

      e.preventDefault();
      return true;
    });
  }
}
